module.exports = __webpack_public_path__ + "img/mobile-screen.bf885303.png";